

import Accounts from "./Accounts";


class Google extends Accounts{
    constructor(params) {
      super(params);
    this.accountType = 'Google';
    
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
}

export default Google;
  